import type { IconAsset } from '../Icon.types';

export const instagram: IconAsset = {
  regular: {
    l: {
      code: (
        <g>
          <path
            clipRule='evenodd'
            d='M6.79688 12C6.79688 9.12657 9.12657 6.79688 12 6.79688C14.8734 6.79688 17.2031 9.12657 17.2031 12C17.2031 14.8734 14.8734 17.2031 12 17.2031C9.12657 17.2031 6.79688 14.8734 6.79688 12ZM8.74805 12.002C8.74805 13.7944 10.2075 15.2539 12 15.2539C13.7925 15.2539 15.252 13.7944 15.252 12.002C15.252 10.2082 13.7925 8.75 12 8.75C10.2075 8.75 8.74805 10.2082 8.74805 12.002Z'
            fill='currentColor'
            fillRule='evenodd'
          />
          <path
            d='M17.5937 7.10148C17.9766 7.10148 18.287 6.79107 18.287 6.40816C18.287 6.02525 17.9766 5.71484 17.5937 5.71484C17.2108 5.71484 16.9004 6.02525 16.9004 6.40816C16.9004 6.79107 17.2108 7.10148 17.5937 7.10148Z'
            fill='currentColor'
          />
          <path
            clipRule='evenodd'
            d='M8.09766 1.59375H15.9023C19.4938 1.59375 22.4062 4.5062 22.4062 8.09766V15.9023C22.4062 19.4938 19.4938 22.4062 15.9023 22.4062H8.09766C4.5062 22.4062 1.59375 19.4938 1.59375 15.9023V8.09766C1.59375 4.5062 4.5062 1.59375 8.09766 1.59375ZM15.9023 20.457C18.4129 20.457 20.4551 18.4148 20.4551 15.9043V8.09961C20.4551 5.5891 18.4129 3.54688 15.9023 3.54688H8.09766C5.58715 3.54688 3.54492 5.5891 3.54492 8.09961V15.9043C3.54492 18.4148 5.58715 20.457 8.09766 20.457H15.9023Z'
            fill='currentColor'
            fillRule='evenodd'
          />
        </g>
      ),
    },
    m: {
      code: (
        <g>
          <path
            clipRule='evenodd'
            d='M5.66406 10C5.66406 7.60548 7.60548 5.66406 10 5.66406C12.3945 5.66406 14.3359 7.60548 14.3359 10C14.3359 12.3945 12.3945 14.3359 10 14.3359C7.60548 14.3359 5.66406 12.3945 5.66406 10ZM7.29004 10.0016C7.29004 11.4954 8.50627 12.7116 10 12.7116C11.4937 12.7116 12.71 11.4954 12.71 10.0016C12.71 8.50681 11.4937 7.29167 10 7.29167C8.50627 7.29167 7.29004 8.50681 7.29004 10.0016Z'
            fill='currentColor'
            fillRule='evenodd'
          />
          <path
            d='M14.6614 5.9179C14.9805 5.9179 15.2392 5.65922 15.2392 5.34013C15.2392 5.02104 14.9805 4.76237 14.6614 4.76237C14.3423 4.76237 14.0837 5.02104 14.0837 5.34013C14.0837 5.65922 14.3423 5.9179 14.6614 5.9179Z'
            fill='currentColor'
          />
          <path
            clipRule='evenodd'
            d='M6.74805 1.32812H13.252C16.2448 1.32812 18.6719 3.75517 18.6719 6.74805V13.252C18.6719 16.2448 16.2448 18.6719 13.252 18.6719H6.74805C3.75517 18.6719 1.32812 16.2448 1.32812 13.252V6.74805C1.32812 3.75517 3.75517 1.32812 6.74805 1.32812ZM13.252 17.0475C15.344 17.0475 17.0459 15.3457 17.0459 13.2536V6.74967C17.0459 4.65758 15.344 2.95573 13.252 2.95573H6.74805C4.65596 2.95573 2.9541 4.65758 2.9541 6.74967V13.2536C2.9541 15.3457 4.65596 17.0475 6.74805 17.0475H13.252Z'
            fill='currentColor'
            fillRule='evenodd'
          />
        </g>
      ),
    },
    s: {
      code: (
        <g>
          <path
            clipRule='evenodd'
            d='M4.53125 8C4.53125 6.08438 6.08438 4.53125 8 4.53125C9.91562 4.53125 11.4688 6.08438 11.4688 8C11.4688 9.91562 9.91562 11.4688 8 11.4688C6.08438 11.4688 4.53125 9.91562 4.53125 8ZM5.83203 8.0013C5.83203 9.19629 6.80502 10.1693 8 10.1693C9.19498 10.1693 10.168 9.19629 10.168 8.0013C10.168 6.80545 9.19498 5.83333 8 5.83333C6.80502 5.83333 5.83203 6.80545 5.83203 8.0013Z'
            fill='currentColor'
            fillRule='evenodd'
          />
          <path
            d='M11.7291 4.73432C11.9844 4.73432 12.1913 4.52738 12.1913 4.27211C12.1913 4.01683 11.9844 3.8099 11.7291 3.8099C11.4739 3.8099 11.2669 4.01683 11.2669 4.27211C11.2669 4.52738 11.4739 4.73432 11.7291 4.73432Z'
            fill='currentColor'
          />
          <path
            clipRule='evenodd'
            d='M5.39844 1.0625H10.6016C12.9959 1.0625 14.9375 3.00413 14.9375 5.39844V10.6016C14.9375 12.9959 12.9959 14.9375 10.6016 14.9375H5.39844C3.00413 14.9375 1.0625 12.9959 1.0625 10.6016V5.39844C1.0625 3.00413 3.00413 1.0625 5.39844 1.0625ZM10.6016 13.638C12.2752 13.638 13.6367 12.2765 13.6367 10.6029V5.39974C13.6367 3.72607 12.2752 2.36458 10.6016 2.36458H5.39844C3.72477 2.36458 2.36328 3.72607 2.36328 5.39974V10.6029C2.36328 12.2765 3.72477 13.638 5.39844 13.638H10.6016Z'
            fill='currentColor'
            fillRule='evenodd'
          />
        </g>
      ),
    },
  },
};
